import React, { useState, useEffect, useContext } from 'react'

import { FiltersContext } from 'client/components/FiltersContainer/context'
import Checkbox from 'src/comps/Checkbox'

import { ACCOMMODATION_TYPES } from './constants'
import { FilterAccommodationTypesBase, Title, List } from './styles'
import { useS4LContext } from '@s4l/react-context'

const FilterAccommodationTypes = () => {
  const { i18n } = useS4LContext()

  const { filters, setFilters } = useContext(FiltersContext)
  const [selected, setSelected] = useState<string[]>([])

  useEffect(() => {
    setSelected(filters.accommodationTypes || [])
  }, [filters.accommodationTypes])

  function handleClick(accommodation: string) {
    const index = selected.indexOf(accommodation)
    const accommodationExists = index > -1
    const filteredAccommodations = accommodationExists
      ? selected.filter((f, i) => i !== index)
      : [...selected, accommodation]

    setFilters({ ...filters, accommodationTypes: filteredAccommodations })
  }

  const keys = {
    hotel: i18n.formatMessage({ id: 'global.hotel' }),
    apartment: i18n.formatMessage({ id: 'global.apartment' }),
    villa: i18n.formatMessage({ id: 'global.villa' }),
    homes: i18n.formatMessage({ id: 'global.homes' }),
    hostel: i18n.formatMessage({ id: 'global.hostel' }),
    resort: i18n.formatMessage({ id: 'global.resort' }),
    apthotel: i18n.formatMessage({ id: 'global.apthotel' }),
  } as const

  return (
    <FilterAccommodationTypesBase>
      <Title>{i18n.formatMessage({ id: 'global.accommodation' })}</Title>

      <List>
        {ACCOMMODATION_TYPES.map(accommodation => {
          const { name, slug } = accommodation
          const isSelected = !!selected.find(f => f === slug)

          return (
            <li key={`accommodation-${slug}`}>
              <Checkbox
                label={keys[name as keyof typeof keys]}
                name={`accommodation-${slug}`}
                onChange={() => handleClick(slug)}
                selected={isSelected}
              />
            </li>
          )
        })}
      </List>
    </FilterAccommodationTypesBase>
  )
}

export default FilterAccommodationTypes
